import { i18next } from '@/i18n'

export default {
  path: 'prompt-libraries/',
  name: 'prompt-libraries',
  props: true,
  meta: {
    auth: 'ROLE_USER',
    title: i18next.t('prompt.linkpromptLibraries')
  },
  component: () =>
    import(/* webpackChunkName: "prompt" */ '../pages/prompt/index.vue')
}
